function Redirect() {
  window.location.href = process.env.REACT_APP_REDIRECT_URI;
  return null;
}

export default Redirect;
